import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faGithub, faLinkedinIn, } from '@fortawesome/free-brands-svg-icons';
import React from 'react';
import { faMailBulk } from '@fortawesome/free-solid-svg-icons';

const Footer = () => {
    const date = new Date();
    const currentYear = date.getFullYear();
    return (
        <footer className="text-[10px] sm:text-xs font-audiowide border-t-[1px] border-t-[rgb(255,255,255,.15)] footer footer-center gap-6 sm:gap-9 p-4 lg:flex lg:justify-around overflow-hidden">
            <div className="grid grid-flow-col gap-12 transform text-white">
                <a target="blank" href="https://www.linkedin.com/in/md-shahariar-rahman/" data-aos="fade-right" data-aos-delay="300" data-aos-once="true">
                    <div className='text-white bg-[#0077b5] px-1 py-[1px] rounded hover:scale-125 duration-150'>
                        <FontAwesomeIcon className='h-5 w-5 hover:scale-110 duration-200' icon={faLinkedinIn} />
                    </div>
                </a>
                <a target="blank" href="https://github.com/ShahariarRahman/" data-aos="fade-right" data-aos-once="true">
                    <div className='text-black bg-gray-300 px-1 py-[1px] rounded hover:scale-125 duration-150'>
                        <FontAwesomeIcon className='h-5 w-5' icon={faGithub} />
                    </div>
                </a>
                < a target="blank" href="https://mail.google.com/mail/?view=cm&fs=1&to=shahariarrahman98@gmail.com" data-aos="fade-left" data-aos-once="true">
                    <div className='text-gray-300 bg-[#c92c32] px-1 pt-[2px] rounded hover:scale-125 duration-150'>
                        <FontAwesomeIcon className='h-5 w-5' icon={faMailBulk} />
                    </div>
                </a >
                <a target="blank" href="https://www.facebook.com/shahariarrahman98/" data-aos="fade-left" data-aos-delay="300" data-aos-once="true">
                    <div className='bg-[#005ee4] text-white px-1 pt-[2px] rounded hover:scale-125 duration-150'>
                        <FontAwesomeIcon className='h-5 w-5' icon={faFacebookF} />
                    </div>
                </a>
            </div >
            <p className='text-gray-300'>Copyright &#169; {currentYear} - All right reserved by Md. Shahariar Rahman</p>
        </footer >
    );
};

export default Footer;